import React from "react";
import {Input, Button, Table, DatePicker, Select, TimePicker, Pagination} from "antd";

import locale from 'antd/es/date-picker/locale/zh_CN';

import {SearchOutlined, ToTopOutlined} from '@ant-design/icons';
import Refund from "../ordersList/com/refund";//退款
import PrintPro from "../../components/ExportOrder/printPro";/////批量导出订单
import './index.sass'
import UserInfo from "../../components/UserInfo";
import api from "../../utils/api";
import qs from "../../utils/qs";


const {RangePicker} = DatePicker;
const {Option} = Select;
export default class AfterSales extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            ordersOptionsFlag: 0,
            show_refund_param: {},
            dataSource: [],
            page: 1,
            total: 0,
            show_refund: true,
            show_export: {},
            exportRules: {}
        }
    }

    componentDidMount () {
        this.get_order_after_services()
    }

    get_order_after_services = async (page = 1) => {//售后列表
        this.setState({
            page
        })


        let param = {
            page,
            page_size: 15
        }
        let res = await api('get-order-after-services', param)
        if (res.code === 200) {
            this.setState({
                dataSource: res.data,
                total: res.meta.paginate.total_count
            })
        }
    }


    show_refund_handle = (param) => {//待退款
        this.setState({
            show_refund_param: {
                show: true,
                param: {
                    ...param
                }
            }
        })
    }


    show_export_handle = () => {
        this.setState({
            show_export: {
                show: true
            },
        })
    }


    render () {
        let {ordersOptionsFlag, show_refund_param, dataSource, page, total, show_export, exportRules} = this.state;
        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            },
            getCheckboxProps: (record) => ({
                disabled: record.name === 'Disabled User',
                name: record.name,
            }),
        };

        function onChange () {
        }

        function onSearch () {
        }


        const columns = [
            {
                title: '售后编号',
                width: 180,
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: '发起时间',
                width: 180,
                dataIndex: 'created_at',
                key: 'created_at',
            },
            {
                title: '售后商品',
                width: 180,
                render: (ctx) => {
                    return (
                        ctx.products.map((item, index) => {
                            return (
                                <p className='product_name' title={item.name}>
                                    {index + 1}、 {item.name}
                                </p>
                            )
                        })
                    )
                }
            },
            {
                title: '售后金额',
                width: 180,
                dataIndex: 'refund_total_amount',
                key: 'refund_total_amount',
            },
            {
                title: '售后状态',
                width: 180,
                render: (ctx) => {
                    return (
                        <p>{qs.afterSaleStatus(ctx.status)}</p>
                    )
                }
            },
            {
                title: '售后理由',
                render: (ctx) => {

                    return (
                        <p className='themeColor pointer' onClick={() => {
                            this.show_refund_handle(ctx)
                        }}>查看理由&gt;</p>
                    )

                }
            },
            {
                title: '关联团购编号',
                width: 180,
                dataIndex: 'order_gb_id',
                key: 'order_gb_id',
            },
            {
                title: '关联订单编号',
                width: 180,
                dataIndex: 'order_id',
                key: 'order_id',
            },
            {
                title: '订单类型',
                width: 180,
                render: (ctx) => {
                    return (
                        <p>
                            {ctx.order_type === 'gb' ? '团购订单' : '商城订单'}
                        </p>
                    )
                }
            },
        ]
        return (
            <div className='afterSales'>
                <UserInfo/>
                <div className='record'>
                    <div className='change_fans flex'>
                        <div className='flex line alignCenter mgr40'>
                            售后编号：
                            <Input placeholder='售后编号：'/>
                        </div>
                        <div className='flex line alignCenter mgr40'>
                            搜索用户/商户：
                            <Input placeholder='搜索用户/商户：'/>
                        </div>
                        <div className='flex line alignCenter mgr40'>
                            售后状态：
                            <Select
                                showSearch
                                placeholder="全部"
                                optionFilterProp="children"
                                onChange={onChange}
                                onSearch={onSearch}
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                <Option value="jack">全部</Option>
                            </Select>
                        </div>
                        <div className='flex line alignCenter mgr40'>
                            订单编号：
                            <Input placeholder='订单编号：'/>
                        </div>
                        <div className='flex line alignCenter mgr40'>
                            到货时间：
                            <RangePicker locale={locale}/>
                        </div>
                        <div className='flex line alignCenter mgr40'>
                            截团时刻：
                            <TimePicker.RangePicker onChange={(e, d) => {
                                this.setState({end_time: d.join('~')})
                            }} locale={locale} style={{width: 200}} format={'HH:mm'}/>
                        </div>
                        <Button className='mgr10 themeBtn' icon={<SearchOutlined/>}>搜索</Button>
                        <Button className='mgr10'>重置</Button>
                    </div>
                    <div className='change_fans'>
                        <div className='flex alignCenter screen mgb10'>
                            <ul className='flex ordersOptions'>
                                <li className={ordersOptionsFlag === 0 ? 'active' : ''}>全部售后</li>
                                <li className={ordersOptionsFlag === 1 ? 'active' : ''}>待售后</li>
                                <li className={ordersOptionsFlag === 2 ? 'active' : ''}>售后中</li>
                                <li className={ordersOptionsFlag === 3 ? 'active' : ''}>已售后</li>
                            </ul>

                            <div className='flex alignCenter'>
                                <Button icon={<ToTopOutlined/>} className='themeBtn' size='' onClick={() => {
                                    this.show_export_handle()
                                }}>批量导出售后</Button>
                            </div>
                        </div>
                        <Table rowSelection={{
                            ...rowSelection,
                        }} dataSource={dataSource} columns={columns} pagination={false} scroll={
                            {
                                scrollToFirstRowOnChange: false,
                                x: false
                            }
                        }/>
                    </div>

                    <div className='page_style'>
                        <Pagination
                            page_size={15}
                            hideOnSinglePage={true}
                            onChange={(e) => {
                                this.get_order_after_services(e)
                            }}
                            defaultCurrent={1} showSizeChanger={false}
                            current={page}
                            total={total}/>
                    </div>
                    {
                        show_refund_param.show ? (
                            <Refund show_refund_param={show_refund_param} colsePop={(e) => {
                                let {show_refund_param} = this.state
                                show_refund_param.show = e.show;
                                this.setState({
                                    show_refund_param
                                })
                            }}/>
                        ) : null
                    }
                </div>
                {
                    show_export.show ? (<PrintPro isRefund={true} showSet={(show) => {
                        if (!show) {
                            show_export.show = false;
                            this.setState({
                                show_export
                            })
                        }
                    }} exportRules={exportRules} jumpUrl={e => {
                        this.props.history.push(e)
                    }} colsePop={(e) => {
                        show_export.show = false;
                        this.setState({
                            show_export
                        })
                    }}/>) : null
                }
            </div>
        )
    }
}